import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatSnackBar,
  MatDialog,
  MatTabChangeEvent,
} from "@angular/material";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { UtilityService } from "src/app/services/utility.service";
import { LoaderService } from "src/app/services/loader.service";
import { AllocatePointsService } from "src/app/services/allocate-points.service";
import { ConfirmationDialogComponent } from "src/app/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-allocate-points",
  templateUrl: "./allocate-points.component.html",
  styleUrls: ["./allocate-points.component.css"],
})
export class AllocatePointsComponent implements OnInit {
  data: any = {};
  response: any = {};
  settings: any;
  model: any = {};
  from: number = 1;
  to: number = 25;
  totalRecord: number;
  years = new Date().getFullYear() - 1;
  yearList: any = [];
  IsAllocatePoints = false;
  showTripSelection = false;
  IsAllocated = false;
  searchText = "";
  selectedTripIds: any[] = [];
  tripOptions: any = [];
  currentStep: number = 0;
  importedData: any[] = [];
  selectedTabIndex: number = 0;
  lastCacheRefreshTime: string = "";
  allocationSuccessMessage: string = "";

  sortColumn: string = "CompanyName";
  sortOrder: string = "ASC";
  pageSize: number = 25;
  pageIndex: number = 0;
  totalRecordCount: number = 0;

  includeUnAllocated: boolean = false;
  private searchSubject = new Subject<string>();

  res: any = {};
  public displayedColumns = [
    "customerNumber",
    "companyName",
    "totalEarnPoints",
    "totalTripPoints",
    "balancePoints",
  ];

  public displayedEligibleColumns = [
    "customerNumber",
    "companyName",
    "totalEarnPoints",
    "totalTripPoints",
    "balancePoints",
  ];

  public eligibleCustomerDataSource = new MatTableDataSource<CustomerEntity>();

  public dataSource = new MatTableDataSource<CustomerEntity>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild("eligibleSort", { static: false })
  set eligibleSort(value: MatSort) {
    if (value) {
      this.eligibleCustomerDataSource.sort = value;
    }
  }

  @ViewChild("eligiblePaginator", { static: false })
  set eligiblePaginator(value: MatPaginator) {
    if (value) {
      this.eligibleCustomerDataSource.paginator = value;
    }
  }

  public importedDataSource = new MatTableDataSource<CustomerEntity>();

  @ViewChild("importedSort", { static: false })
  set importedSort(value: MatSort) {
    if (value) {
      this.importedDataSource.sort = value;
    }
  }

  @ViewChild("importedPaginator", { static: false })
  set importedPaginator(value: MatPaginator) {
    if (value) {
      this.importedDataSource.paginator = value;
    }
  }

  uploadedFile: File = null;
  uploadedFileName: string = "";
  uploadError: string = "";
  importErrors: any[] = [];
  showTripValidation = false;

  public displayedImportColumns = [
    "customerNumber",
    "companyName",
    "totalEarnPoints",
    "totalTripPoints",
    "balancePoints",
    "status",
  ];

  currentUserId = this._utilityService.getCurrentUserId();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") private baseUrl: string,
    private _allocatePointsService: AllocatePointsService,
    private _utilityService: UtilityService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private _loaderService: LoaderService,
  ) {
    let url = this._router.url;
    if (url == "/allocated-points") {
      this.IsAllocated = true;
    }
  }
  applyFilter(filterValue: string) {
    this.searchSubject.next(filterValue.trim());
  }

  applyEligibleCustomerFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.searchText = filterValue;
    this.eligibleCustomerDataSource.filter = filterValue;
  }

  applyImportedDataFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.searchText = filterValue;
    this.importedDataSource.filter = filterValue;
  }

  applyAllocatedFilter(filterValue: string) {
    this.allocatedSearchSubject.next(filterValue.trim());
  }

  onAllocatedSortChange(event: any) {
    this.allocatedSortColumn = event.active || "CompanyName";
    this.allocatedSortOrder = event.direction === "desc" ? "DESC" : "ASC";
    this.allocatedPageIndex = 0;
    this.bindAllocatedPointsList();
  }

  onAllocatedPageChange(event: any) {
    this.allocatedPageSize = event.pageSize;
    this.allocatedPageIndex = event.pageIndex;
    this.bindAllocatedPointsList();
  }

  ngOnInit() {
    this.searchSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value) => {
        this.searchText = value;
        this.pageIndex = 0;
        this.bindPointsList();
      });

    this.allocatedSearchSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value) => {
        this.allocatedSearchText = value;
        this.allocatedPageIndex = 0;
        this.bindAllocatedPointsList();
      });

    this.bindPointsList();
    this.getTripOptions();
    this.loadLastRefreshTime();
  }
  ngAfterViewInit() {}

  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.bindPointsList();
  }

  onSortChange(event: any) {
    this.sortColumn = event.active || "CompanyName";
    this.sortOrder = event.direction === "desc" ? "DESC" : "ASC";
    this.pageIndex = 0;
    this.bindPointsList();
  }

  // confirmAllocatePoints() {
  //   //allocating points to customers may take a few minutes. Do you want to proceed?
  //   if (
  //     confirm(
  //       "Allocating points to customers may take a few minutes. Do you want to proceed?",
  //     )
  //   ) {
  //     this._allocatePointsService.savePointsAllocation().subscribe((result) => {
  //       this.response = result;
  //       if (this.response.messageCode == 1) {
  //         this._allocatePointsService.refreshPointsCache().subscribe();
  //         localStorage.setItem("Allocated", JSON.stringify(result));
  //         this._router.navigate(["/allocated-points"]);
  //       }
  //     });
  //   }
  // }

  confirmAllocatePoints() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "450px",
      disableClose: true,
      data: {
        title: "Confirm Allocation",
        message:
          "Allocating points to customers may take a few minutes. Do you want to proceed?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this._allocatePointsService
          .savePointsAllocation()
          .subscribe((response) => {
            if (response.messageCode === 1) {
              this._allocatePointsService.refreshPointsCache().subscribe();
              localStorage.setItem("Allocated", JSON.stringify(response));
              this._router.navigate(["/allocated-points"]);
            }
          });
      }
    });
  }

  // Add these new properties after existing ones
  allocatedSortColumn: string = "CompanyName";
  allocatedSortOrder: string = "ASC";
  allocatedPageSize: number = 25;
  allocatedPageIndex: number = 0;
  allocatedTotalRecordCount: number = 0;
  allocatedSearchText: string = "";
  private allocatedSearchSubject = new Subject<string>();

  public allocatedDataSource = new MatTableDataSource<CustomerEntity>();
  bindPointsList() {
    this.allocatedSearchText = "";
    // console.log("Binding points list. IsAllocated:", !this.IsAllocated);
    if (!this.IsAllocated) {
      this._loaderService.show("Putting the pieces together… please stand by.");
      this._allocatePointsService
        .getCachedAllocatePointsList(
          this.sortColumn,
          this.sortOrder,
          this.searchText,
          this.pageSize,
          this.pageIndex + 1,
        )
        .subscribe((result) => {
          this._loaderService.hide();
          this.response = result;
          this.dataSource.data = this.response.data as CustomerEntity[];
          this.totalRecordCount = this.response.totalCount || 0;
          if (localStorage.getItem("Allocated") != null) {
            this.response = JSON.parse(localStorage.getItem("Allocated"));
            localStorage.removeItem("Allocated");
          }
        });
    } else {
      this.bindAllocatedPointsList();
    }
  }
  // Replace existing onTabChange
  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    this.searchText = "";
    this.allocatedSearchText = "";
    // Only clear success message when switching away from Allocated tab
    if (event.index !== 1) {
      this.allocationSuccessMessage = "";
    }
    if (event.index === 1) {
      this.allocatedPageIndex = 0;
      this.bindAllocatedPointsList();
    } else if (event.index === 0) {
      this.pageIndex = 0;
      this.bindPointsList();
    }
  }

  // Fetch Allocated Points (isAllocated = true) for the second tab
  bindAllocatedPointsList() {
    this._loaderService.show("Putting the pieces together… please stand by.");
    this._allocatePointsService
      .getAllocatePointsList(
        true, // isAllocated = true (always for Allocated Points tab)
        this.allocatedSortColumn,
        this.allocatedSortOrder,
        this.allocatedSearchText,
        this.allocatedPageSize,
        this.allocatedPageIndex + 1,
      )
      .subscribe((result) => {
        this._loaderService.hide();
        this.allocatedDataSource.data = result.data as CustomerEntity[];
        this.allocatedTotalRecordCount = result.totalCount || 0;
        // console.log("Allocated Points List:", this.allocatedDataSource.data);
      });
  }
  loadLastRefreshTime() {
    this._allocatePointsService
      .getLastCacheRefreshTime()
      .subscribe((result) => {
        if (result && result.lastRefreshedAt) {
          const date = new Date(result.lastRefreshedAt);
          this.lastCacheRefreshTime = date.toLocaleString();
        }
      });
  }
  getTripOptions() {
    this._allocatePointsService.getTripOptions().subscribe((result) => {
      this.tripOptions = result;
    });
  }

  toggleTripSelection(tripId: any) {
    const index = this.selectedTripIds.indexOf(tripId);
    if (index === -1) {
      this.selectedTripIds.push(tripId);
    } else {
      this.selectedTripIds.splice(index, 1);
    }
    if (this.selectedTripIds.length > 0 || this.includeUnAllocated) {
      this.showTripValidation = false;
    }
  }
  toggleUnAllocated() {
    this.includeUnAllocated = !this.includeUnAllocated;
    if (this.includeUnAllocated) {
      this.showTripValidation = false;
    }
  }

  startAllocation() {
    this.currentStep = 1;
    this.showTripSelection = true;
  }

  selectTab(tabNumber: number) {
    this.currentStep = tabNumber;
  }

  back() {
    this.uploadedFile = null;
    this.uploadedFileName = "";
    this.response = {};
    this.res = {};
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  proceedToReview() {
    if (this.selectedTripIds.length === 0 && !this.includeUnAllocated) {
      this.showTripValidation = true;
      return;
    }

    this.showTripValidation = false;
    const finalTripIds = this.selectedTripIds.slice();

    // Internally include optional (catalog) trip IDs when any regular trip is selected
    const hasRegularTripSelected = this.selectedTripIds.some(
      (id) => !this.tripOptions.find((t) => t.id === id && t.isOptional),
    );
    if (hasRegularTripSelected) {
      this.tripOptions
        .filter((t) => t.isOptional == 1 && !finalTripIds.includes(t.id))
        .forEach((t) => finalTripIds.push(t.id));
    }

    // Only prepend 0 when includeUnAllocated is checked
    if (this.includeUnAllocated) {
      finalTripIds.unshift(0);
    }

    //console.log("Final Trip IDs sent to API:", finalTripIds);
    this._loaderService.show("Putting the pieces together… please stand by.");
    this._allocatePointsService
      .getEligibleCustomersForSelectedTrips(finalTripIds)
      .subscribe((result) => {
        this._loaderService.hide();
        this.response = result;
        this.eligibleCustomerDataSource.data = this.response
          .data as CustomerEntity[];
        this.currentStep = 2;
      });
  }

  getSelectedTripNames(): string {
    const names = this.tripOptions
      .filter(
        (t) =>
          (this.selectedTripIds.includes(t.id) && !t.isOptional) ||
          (t.isOptional == 1 && this.selectedTripIds.includes(t.id)),
      )
      .map((t) => t.tripCode);
    if (this.includeUnAllocated) {
      names.push("No trip enrollment Customers");
    }
    return names.join(", ");
  }

  getStepIndicatorClass(step: number) {
    if (this.currentStep >= step) {
      return "bg-custom-blue text-white";
    }
    return "bg-light text-muted";
  }

  getStepTextClass(step: number) {
    if (this.currentStep >= step) {
      return "text-dark font-weight-bold";
    }
    return "text-muted";
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.uploadedFile = event.target.files[0];
      this.uploadedFileName = this.uploadedFile.name;
    }
  }

  uploadAndImport() {
    if (!this.uploadedFile) {
      this.res = {
        messageCode: 2,
        message: "Please select a file to upload",
      };
      return;
    }

    const formData = new FormData();
    formData.append("file", this.uploadedFile);
    formData.append("fileType", "6");

    this._loaderService.show("Putting the pieces together… please stand by.");
    this._allocatePointsService.uploadFile(formData).subscribe((res) => {
      if (res.messageCode === 1) {
        const fileName = res.data;
        this.performImport(fileName);
      } else {
        this._loaderService.hide();
        this.res = res;
      }
    });
  }

  performImport(fileName: string) {
    const model = {
      ImportFileName: fileName,
    };

    this._allocatePointsService
      .importPointsAllocation(model)
      .subscribe((res) => {
        this._loaderService.hide();
        this.res = res;
        if (res.messageCode === 1) {
          this.importedData = this.importedDataSource.data = res.data;
          this.currentStep = 4;
        } else {
        }
      });
  }

  savePointsAllocation() {
    console.log(this.currentUserId);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "450px",
      disableClose: true,
      data: {
        title: "Confirm Allocation",
        message:
          "Are you sure you want to allocate points to the selected customers?",
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed === true) {
        this._loaderService.show(
          "Putting the pieces together… please stand by.",
        );
        this._allocatePointsService
          .saveImportedPointsAllocation(this.importedData, this.currentUserId)
          .subscribe((result) => {
            this._loaderService.hide();
            this.response = result;
            if (this.response.messageCode == 1) {
              // Save success message before bindPointsList overwrites response
              this.allocationSuccessMessage =
                "The selected customer's points have been allocated successfully.";
              this.bindPointsList();
              this.loadLastRefreshTime();
              this.allocatedPageIndex = 0;
              this.bindAllocatedPointsList();
              this.currentStep = 0;
              // Switch to the Allocated Points tab
              this.selectedTabIndex = 1;
              //  console.log(this.allocationSuccessMessage);
            }
          });
      }
    });
  }

  get hasImportErrors(): boolean {
    return (
      this.importedDataSource &&
      this.importedDataSource.data &&
      this.importedDataSource.data.some((x: any) => !x.isValid)
    );
  }
}

export interface CustomerEntity {
  id: number;
  customerId: number;
  customerNumber: string;
  companyName: string;
  totalEarnPoints: string;
  totalTripPoints: string;
  balancePoints: string;
  isValid?: boolean;
  validationMessage?: string;
}
